/** JSON with object keys sorted at every level, so equal content gives equal text. */
export const canonicalJson = (value: unknown): string => {
  if (value === null || typeof value !== "object") return JSON.stringify(value) ?? "null"
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`
  const record = value as Record<string, unknown>
  const keys = Object.keys(record)
    .filter((k) => record[k] !== undefined)
    .sort()
  return `{${keys.map((k) => `${JSON.stringify(k)}:${canonicalJson(record[k])}`).join(",")}}`
}

/** FNV-1a 32-bit, 8 hex characters. Names engine temporaries; not a security hash. */
export const fnv1a = (text: string): string => {
  let h = 0x811c9dc5
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i)
    h = Math.imul(h, 0x01000193)
  }
  return (h >>> 0).toString(16).padStart(8, "0")
}

/** Hash of a document's content: approval and the updated stamps are left out. */
export const contentHash = <
  T extends { approval?: unknown; updatedAt?: unknown; updatedBy?: unknown },
>(
  doc: T
): string => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { approval: _a, updatedAt: _t, updatedBy: _b, ...content } = doc
  return fnv1a(canonicalJson(content))
}
